import { useParams } from 'react-router-dom';

import { getProjectPath, getProjectsBasePath } from '@verantos-dev/core-constants';
import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

/**
 * Breadcrumbs for the gen-3 cohort detail header (OR-6123 F8):
 * `Project home / <cohort>`.
 *
 * The project header no longer carries the breadcrumb, so the cohort detail
 * page renders its own. Co-located here rather than in feature-project-page —
 * feature-cohort-builder can't depend on it without inverting the layering.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const useCohortDetailBreadcrumbs = (
  cohortName: string,
  isLoading = false
): PageHeaderBreadcrumb[] => {
  const { projectId = '' } = useParams<{ projectId: string }>();

  return [
    {
      label: 'Project home',
      href: projectId ? getProjectPath(projectId) : getProjectsBasePath(),
    },
    { label: cohortName, isLoading: isLoading && !cohortName },
  ];
};
